import React, { Component, Dispatch } from 'react';
import { Common } from '../../core/common';
import * as Actions from '../../store/actions/messages';
import { MessagesService } from '../../api/message-services';
import { SecureImage } from '../../components/core/secureImage';
import { Log } from 'ng2-logger';
import Translator from '../../core/i18n';
import ReactGA from 'react-ga4';

const T = Translator.create();
const _logger = Log.create('groupListItem.tsx');

const defaultChatLogo = `${process.env.PUBLIC_URL}/images/message/message.jpg`;
let _common: Common;
const messagesService = new MessagesService();

export class CGroupListItem extends Component<any, any> {
    constructor(props: any) {
        super(props);
        _common = new Common();
    }

    openChat = () => {
        ReactGA.event({
            category: window.location.host,
            action: 'G_GROUPS_X_MESSAGE_CLICKED',
            label:'G_GROUPS_X_MESSAGE_CLICKED',
            nonInteraction: true,
          });
        messagesService.RequestGetOriginMessageAsync(this.props.classId, 'Class').then(data => {

            if (data && data.length > 0) {
                this.props.dispatch(
                    Actions.getMessageListAction({
                        skip: 0,
                        take: 10,
                        originMessageId: data,
                        contextType: 1, // Class
                        contextId: this.props.classId,
                        imageUrl: this.props.logoUrl,
                        chatTitleText: this.props.groupName,
                        spinnerId: 'getMessageListAction',
                        spinnerType: 'get',
                        callback: this.openChatCallBack
                    })
                );
            } else {
                this.props.dispatch(
                    Actions.setMessageListAction(
                        [],
                        '-1',
                        0,
                        100,
                        0,
                        this.props.groupName,
                        this.props.logoUrl,
                        this.props.classId,
                        1,
                        'getMessageListAction',
                        'set'
                    )
                );
            }
        });
    };
    openChatCallBack = () => {
        const item = document.getElementById('chatPanel');
        const itemContactList = document.getElementById('chatContactList');
        const blankChatPanelText = document.getElementById('blankChatPanelText');
        if (item) {
            item.className = 'conversation-window relative mobile_chat_panel display_sm';
            if (itemContactList) {
                itemContactList.className = 'main-sidebar display_sm_none';
                if(blankChatPanelText) {
                    blankChatPanelText.className = 'create-announcement text-center display_sm_none';
                }
            }
        }
    }
    getBackgroundColor(name: string) {
        const colors = ["#008ce3", "#00204d", "#db4f3d", "#004381", "#ffc622", "#0a0a0a"];
        if (!name || name.length === 0) return colors[0];

        let hash = 0;
        for (let i = 0; i < name.length; i++) {
          hash = name.charCodeAt(i) + ((hash << 5) - hash);
        }

        const index = Math.abs(hash) % colors.length;
        return colors[index];
      }
    public render() {
        return (
            <div className="media" onClick={this.openChat}>
                     <div
                className="chat_avatar_placeholder"
                style={{
                  backgroundColor: this.getBackgroundColor(this.props.groupName)
                }}
              >
                {this.props.groupName && this.props.groupName.length > 0 ? this.props.groupName.charAt(0).toUpperCase() : ''}
              </div>
                <div className="media-body">
                    <span
                        style={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'normal'
                        }}
                        onClick={this.openChat}
                    >
                        {this.props.groupName}
                    </span>

                </div>
            </div>
        );
    }
}

export default CGroupListItem;
